const parseSettlementMaximumOunces = settlementOunces =>
  settlementOunces && {
    platinumOz: settlementOunces.maximumPlatinumOz,
    palladiumOz: settlementOunces.maximumPalladiumOz,
    rhodiumOz: settlementOunces.maximumRhodiumOz,
  };

export { parseSettlementMaximumOunces };
